import { StakeholderOverviewTable } from '@/components';

export default {
  name: 'StakeholderOverview',
  components: {
    [StakeholderOverviewTable.name]: StakeholderOverviewTable,
  },
  props: {},
  data: () => ({
    search: '',
    snackbar: false,
    snackbarMessage: '',
  }),
  computed: {},
  methods: {
    createNewStakeholder() {
      this.$router.push({ name: 'stakeholder' });
    },
    showSnackbar(message) {
      if (message.response) {
        if (message.response.status === 400) {
          this.snackbarMessage = message.response.data;
        } else {
          this.snackbarMessage = 'Something went wrong';
        }
      } else {
        this.snackbarMessage = message;
      }

      this.snackbar = true;
    },
  },
  created() {
    this.$eventHub.$on('show-snackbar', this.showSnackbar);
  },
};
